import React from 'react';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero';
import ProductGrid from '../components/ProductGrid';

const Home: React.FC = () => {
  const { t } = useTranslation();

  return (
    <main>
      <Hero />

      {/* Virtual Spomenik Feature Section - Hidden until SMTP setup complete */}
      {/* <section className="border-t-[3px] border-b-[3px] border-black bg-[#C41E3A] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 border-8 border-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 border-8 border-white rounded-full translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="max-w-7xl mx-auto px-8 py-16 md:py-24 relative z-10">
          <div className="text-center text-white">
            <div className="inline-block border-4 border-white px-4 py-2 mb-6 rotate-[-2deg]">
              <div className="text-xs font-black uppercase tracking-wider">
                New Official Program
              </div>
            </div>
            <h2 className="text-4xl md:text-6xl font-black uppercase leading-none mb-6 tracking-tighter">
              Commission Your<br />Virtual Spomenik
            </h2>
            <p className="text-lg md:text-xl font-bold uppercase max-w-3xl mx-auto mb-8 leading-relaxed">
              Erect an eternal monument in someone's name. Receive an official certificate with Tito's signature, bureaucratic stamps, and a unique registry number.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-xs font-black uppercase mb-10">
              <div className="border-2 border-white px-4 py-2 bg-black bg-opacity-20">
                ✓ Official Certificate
              </div>
              <div className="border-2 border-white px-4 py-2 bg-black bg-opacity-20">
                ✓ Tito's Signature
              </div>
              <div className="border-2 border-white px-4 py-2 bg-black bg-opacity-20">
                ✓ Registry Number
              </div>
              <div className="border-2 border-white px-4 py-2 bg-black bg-opacity-20">
                ✓ From $19.99
              </div>
            </div>
            <Link
              to="/virtual-spomenik"
              className="inline-block bg-black text-white px-8 py-4 font-black uppercase tracking-tighter text-lg border-4 border-white hover:bg-white hover:text-black transition-all shadow-[8px_8px_0px_0px_rgba(0,0,0,0.3)]"
            >
              Begin Dedication Process →
            </Link>
          </div>
        </div>
      </section> */}

      <section id="archive" className="border-t-[3px] border-black">
        <div className="bg-black text-white px-4 py-2 uppercase font-black text-sm tracking-widest flex justify-between items-center">
          <span>{t('hero.section02')}</span>
          <span className="hidden md:inline">{t('hero.archiveAccess')}</span>
        </div>
        <ProductGrid />
      </section>
    </main>
  );
};

export default Home;
